import React from 'react';
import { Box } from '@mui/material';

const Dot = ({ color = '#2ecc71', size = 8, ...boxProps }) => (
  <Box
    sx={{
      width: size,
      height: size,
      bgcolor: color,
      borderRadius: '50%',
      flexShrink: 0,
    }}
    {...boxProps}
  />
);

export default Dot;
